import { createI18n } from 'vue-i18n'
import en from './lang/en'
import es from './lang/es'

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: 'en',
  fallbackLocale: 'en',
  messages: { en, es },
  // something vue-i18n options here ...
})

export default i18n
